import React, { lazy, Suspense } from 'react'
import { BrowserRouter, Route } from 'react-router-dom'
import { Routes } from 'react-router-dom'
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client'



const Home = lazy(() => import('./pages/Home'))
const Presentation = lazy(() => import('./pages/presentations/Presentation'))
const IntroSlide = lazy(() => import('./pages/presentations/slides/IntroSlide'))
const PresentationSlide = lazy(() => import('./pages/presentations/slides/PresentationSlide'))
const OutroSlide = lazy(() => import('./pages/presentations/slides/OutroSlide'))
const Voting = lazy(() => import('./pages/presentations/mobile/Voting'))

// Loading component with black background
const LoadingFallback = () => (
    <div className="bg-black min-h-screen w-full flex items-center justify-center text-black">
        ...
    </div>
);


function App() {
    const apolloClient = new ApolloClient({
        uri: `${process.env.REACT_APP_API_URL}/graphql`,
        cache: new InMemoryCache({
            typePolicies: {
                Query: {
                    fields: {
                        largeDataField: {
                            merge: false,
                        },
                    },
                },
            },
        }),
    })

    return (
        <BrowserRouter>
            <ApolloProvider client={apolloClient}>
                <Suspense fallback={<LoadingFallback />}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/presentations/:id" element={<Presentation />} />
                        <Route path="/presentations/:id/intro" element={<IntroSlide />} />
                        <Route path="/presentations/:id/outro" element={<OutroSlide />} />
                        <Route
                            path="/presentations/:id/slides/:slideId"
                            element={<PresentationSlide />}
                        />
                        <Route path="/presentations/:id/voting" element={<Voting />} />
                    </Routes>
                </Suspense>
            </ApolloProvider>
        </BrowserRouter>
    )
}

export default App
